import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('h1',[_vm._v("Opciones de administración técnica")]),(!_vm.erudaEstaHabilitado)?[_c(VBtn,{on:{"click":_vm.mostrarEruda}},[_vm._v("Habilitar DevTools")])]:[_c(VBtn,{on:{"click":_vm.inhabilitarEruda}},[_vm._v("Deshabilitar DevTools")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }